import React from 'react';
import type { ViewAnnotation } from './cmx-document-content-adapter';
import { CmxDocumentContentBody } from './cmx-document-content-body';
import './styles/section-viewer.scss';

export type SectionCardProps = {
  title: string;
  bodyMarkdown: string;
  /**
   * Annotations to highlight inside this card. Empty until CDMX-20063 wires
   * span annotation into the sectioned viewer.
   */
  annotations?: ViewAnnotation[];
  /** The body's media type, passed through to CmxDocumentContentBody. */
  mediaType?: string;
  anchorId?: string;
};

export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  bodyMarkdown,
  annotations,
  mediaType,
  anchorId
}) => {
  const hasBody = bodyMarkdown.trim().length > 0;

  return (
    <section id={anchorId} className="cmx-document-content-section">
      <h4 className="cmx-document-content-section__heading">{title}</h4>
      {hasBody ? (
        <CmxDocumentContentBody
          text={bodyMarkdown}
          annotations={annotations}
          mediaType={mediaType}
        />
      ) : (
        <div className="cmx-document-content-section__empty">
          Header only — no body content
        </div>
      )}
    </section>
  );
};
